import {useLayoutEffect, useState, useEffect} from 'react';
import {Platform} from 'react-native';
import {useSelector} from 'react-redux';
import {storage, StorageKeys} from '../../shared/storage';
import {isCardReissueEsiaPending} from '../../shared/storage/cardReissueEsia';
import {httpService, HttpWrapperOptions} from '../../shared/httpWrapper';
import {getApiRoute} from '../../shared/pipes';
import {apiUrls} from '../../shared/constants/urls';
import {esiaUserHasNoCardsSelector} from '../../redux/selectors/login';
import {isStoredActivationSnapshotPending} from './cardActivation';
import {AuthorizeEsiaResponsePayload} from '../../shared/models/api/authorizeEsiaResponsePayload';
import View from './view';

export const LoginScreen = () => {
  const isWeb = Platform.OS === 'web';
  const [esiaLogoutLink, setEsiaLogoutLink] = useState<string | null>(null);
  const userHasNoCards = useSelector(esiaUserHasNoCardsSelector);

  useLayoutEffect(() => {
    if (userHasNoCards || isCardReissueEsiaPending()) return;

    const esiaLogout = async () => {
      const isESIALogin = await storage.getItem(StorageKeys.isESIA);
      if (isESIALogin) {
        try {
          const response = await httpService.get<{link: string}>(
            getApiRoute(apiUrls.esiaLogout),
            new HttpWrapperOptions().WaitTimeout(0).Wait(true).Errors(false).ThrowException(false),
          );
          setEsiaLogoutLink(response?.link ?? null);
        } catch {
          setEsiaLogoutLink(null);
        } finally {
          await storage.removeItem(StorageKeys.isESIA);
        }
      }
    };

    esiaLogout();
  }, [userHasNoCards]);

  useEffect(() => {
    const clearStaleActivationToken = async () => {
      if (userHasNoCards) return;

      const esiaRegInfo = await storage.getItem<AuthorizeEsiaResponsePayload>(StorageKeys.esiaRegInfo);

      if (esiaRegInfo && isStoredActivationSnapshotPending(esiaRegInfo)) return;

      await storage.removeItem(StorageKeys.activationToken);
    };

    clearStaleActivationToken();
  }, [userHasNoCards]);

  if (isWeb && esiaLogoutLink && !userHasNoCards && !isCardReissueEsiaPending()) {
    window.open(esiaLogoutLink, '_self');
    return null;
  }

  return View({esiaLogoutLink});
};
